module.exports = __webpack_public_path__ + "img/cfd1020.jpg";